export enum Toggles {
  EnableViewAs = 'ENABLE_VIEW_AS',
  LiveKeepWatching = 'LIVE_KEEP_WATCHING_HOTMART_CLUB',
  EnableNotificationConsumer = 'ENABLE_NOTIFICATION_CONSUMER',
  EnablesNewHomeExperience = 'ENABLES_NEW_HOME_EXPERIENCE',
  EnableHotmartClubModuleSection = 'ENABLE_HOTMART_CLUB_MODULE_SECTION',
  EnableHotmartClubTrackSection = 'ENABLE_HOTMART_CLUB_TRACK_SECTION',
  EnableCertificateNewExperienceConsumer = 'ENABLE_CERTIFICATE_NEW_EXPERIENCE_CONSUMER',
  EnableCertificatePreviewConsumer = 'ENABLE_CERTIFICATE_PREVIEW_CONSUMER',
  AccountConsumer = 'ACCOUNT_CONSUMER',
  EnableHotmartClubDynamicSections = 'ENABLE_HOTMART_CLUB_DYNAMIC_SECTIONS',
  EnableClubLiveMicrofront = 'ENABLE_CLUB_LIVE_MF'
}
